import { motion, useScroll, useSpring } from 'framer-motion';

/** Top-of-page scroll progress bar with a brand gradient. */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-[70] h-[3px] origin-left bg-gradient-to-r from-brand-500 via-accent-cyan to-accent-fuchsia"
    />
  );
}
